document.addEventListener("DOMContentLoaded", () => {

    /*=========================================
            SCROLL INDICATOR
    =========================================*/

    const indicator = document.querySelector(".ws-scroll-indicator");

    if (indicator) {

        const isOverlayOpen = () => {

            return (
                document.querySelector(".cart-drawer.active") ||
                document.querySelector(".menu-drawer.active") ||
                document.querySelector(".drawer.active") ||
                document.querySelector(".search-modal.active") ||
                document.querySelector(".predictive-search--open") ||
                document.querySelector("details[open]")
            );

        };

        const toggleIndicator = () => {

            indicator.classList.toggle(
                "hide",
                window.scrollY > 30 || isOverlayOpen()
            );

        };

        window.addEventListener("scroll", toggleIndicator, {
            passive: true
        });

        const observer = new MutationObserver(toggleIndicator);

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["class", "open"]
        });

        toggleIndicator();

    }

    /*=========================================
            HERO AURA
    =========================================*/

    const aura = document.querySelector(".ws-hero-aura");

    if (aura) {

        requestAnimationFrame(() => {

            aura.classList.add("play");

        });

    }

});